import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var _a;
import { getSettingEnableDetailedSessionTracing } from "../settings/getSettingEnableDetailedSessionTracing";
import { TelemetryManagerNoOp } from "./TelemetryManagerNoOp";
/**
 * TelemetryManager is a singleton class that manages the OpenTelemetry
 * provider and tracer. It provides methods to start and end traces and spans,
 * and to get the headers for the active trace or span.
 * It also provides methods to start, end, and get headers for managed spans.
 * Managed spans are spans that are created by the TelemetryManager
 * and are not directly associated with the current context.
 */
export var TelemetryManager = /*#__PURE__*/_createClass(function TelemetryManager() {
  _classCallCheck(this, TelemetryManager);
});
_a = TelemetryManager;
TelemetryManager.instance = null;
TelemetryManager.otelPromise = null;
// Add a method to wait for the async loading to complete (for testing)
TelemetryManager.waitForInitialization = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!_a.otelPromise) {
          _context.next = 3;
          break;
        }
        _context.next = 3;
        return _a.otelPromise;
      case 3:
      case "end":
        return _context.stop();
    }
  }, _callee);
}));
TelemetryManager.get = function () {
  if (!_a.instance) {
    if (getSettingEnableDetailedSessionTracing()) {
      if (!_a.otelPromise) {
        _a.otelPromise = import("./TelemetryManagerOtel").then(function (_ref2) {
          var TelemetryManagerOtel = _ref2.TelemetryManagerOtel;
          _a.instance = new TelemetryManagerOtel();
          return _a.instance;
        }).catch(function () {
          _a.instance = new TelemetryManagerNoOp();
          return _a.instance;
        });
      }
      // Return a NoOp instance while loading
      return new TelemetryManagerNoOp();
    } else {
      _a.instance = new TelemetryManagerNoOp();
    }
  }
  return _a.instance;
};
TelemetryManager.reset = function () {
  _a.instance = null;
  _a.otelPromise = null;
};